var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Preview.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Preview = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_966_178974)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19 3.5H5C3.89 3.5 3 4.4 3 5.5V19.5C3 20.6 3.89 21.5 5 21.5H19C20.1 21.5 21 20.6 21 19.5V5.5C21 4.4 20.11 3.5 19 3.5ZM19 19.5H5V7.5H19V19.5ZM13.5 13.5C13.5 14.33 12.83 15 12 15C11.17 15 10.5 14.33 10.5 13.5C10.5 12.67 11.17 12 12 12C12.83 12 13.5 12.67 13.5 13.5ZM12 9.5C9.27 9.5 6.94 11.16 6 13.5C6.94 15.84 9.27 17.5 12 17.5C14.73 17.5 17.06 15.84 18 13.5C17.06 11.16 14.73 9.5 12 9.5ZM12 16C10.62 16 9.5 14.88 9.5 13.5C9.5 12.12 10.62 11 12 11C13.38 11 14.5 12.12 14.5 13.5C14.5 14.88 13.38 16 12 16Z",
      fill: color
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_966_178974",
      children: /*#__PURE__*/_jsx("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0 0.5)"
      })
    })
  })]
});